import { requestPasswordReset } from './passwordReset';

const PASSWORD_RESET_EMAIL_KEY = 'wp_admin_password_reset_email';

export type PasswordResetRequestResult = 'sent' | 'throttled';

/** In-flight lock so double-click / Strict Mode share one request per email. */
const inFlightByEmail = new Map<string, Promise<PasswordResetRequestResult>>();

export function getStoredPasswordResetEmail(): string {
  try {
    return sessionStorage.getItem(PASSWORD_RESET_EMAIL_KEY) ?? '';
  } catch {
    return '';
  }
}

export function writePasswordResetEmail(email: string): void {
  try {
    const normalized = email.trim().toLowerCase();
    if (normalized) sessionStorage.setItem(PASSWORD_RESET_EMAIL_KEY, normalized);
    else sessionStorage.removeItem(PASSWORD_RESET_EMAIL_KEY);
  } catch {
    /* ignore */
  }
}

export async function submitPasswordResetEmail(email: string): Promise<PasswordResetRequestResult> {
  const normalized = email.trim().toLowerCase();
  const existing = inFlightByEmail.get(normalized);
  if (existing) return existing;

  const run = (async (): Promise<PasswordResetRequestResult> => {
    writePasswordResetEmail(normalized);
    const res = await requestPasswordReset(normalized);
    return res.throttled ? 'throttled' : 'sent';
  })().finally(() => {
    inFlightByEmail.delete(normalized);
  });

  inFlightByEmail.set(normalized, run);
  return run;
}

export function passwordResetToastMessage(result: PasswordResetRequestResult): string {
  return result === 'throttled'
    ? 'Trop de demandes. Réessayez plus tard.'
    : 'Si un compte existe pour cet e-mail, un lien de réinitialisation a été envoyé.';
}
